// ** Initial State
const initialState = {
    result_list: [],
    total: 0,
    sign: null,
    timestamp: null,
    endpoint: null,
    notification: null
}

const chatEventList = (state = initialState, action) => {
    switch (action.type) {
        case 'CHAT_EVENT_LIST':
            return {
                ...state,
                result_list: action.data,
                total: action.total
            }
        default:
            return { ...state }
    }
}

const chatSign = (state = initialState, action) => {
    switch (action.type) {
        case 'CHAT_EVENT_SIGN':
            return {
                ...state,
                sign: action.data?.sign || null,
                timestamp: action.data?.timestamp || null,
                endpoint: action.data?.endpoint || null
            }
        default:
            return { ...state }
    }
}

const chatNotification = (state = initialState, action) => {
    switch (action.type) {
        case 'CHAT_NOTIFICATION':
            return {
                ...state,
                notification: action.data || null
            }
        default:
            return { ...state }
    }
}


export {
    chatEventList,
    chatSign,
    chatNotification
}
